var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    x: 0,
    y: 0,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.6 25.7H24c-4-3.8-8.7-8.3-9.6-9-2.9-2-7.8.3-7.8 4.7v17.9c0 3 2.5 5.3 5.1 5.3h14v16.7c0 2 1.7 3.7 3.7 3.7s3.7-1.7 3.7-3.7V40.9c0-2-1.7-3.7-3.7-3.7H17.1v-7.7l2.8 2.7c.7.6 1.6 1 2.5 1h8.1c2 0 3.7-1.7 3.7-3.7.1-2.1-1.6-3.8-3.6-3.8zm0 5.4h-8.1c-.4 0-.8-.2-1.2-.5l-4.5-4.2c-.6-.6-1.7-.1-1.7.7v11c0 .6.4 1 1 1h13.2c.9 0 1.7.8 1.7 1.7v20.4c0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7V43.6c0-.6-.4-1-1-1H11.7c-2.2-.2-3.3-1.7-3.3-3.3V21.4c0-2.9 3.3-3.9 4.8-3 .6.4 5.4 5 9.6 9 .2.2.4.3.7.3h7c.9 0 1.7.8 1.7 1.7.1 1-.7 1.7-1.6 1.7z",
    fill: "#fe4e4e",
    "data-original": "#fe4e4e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 48.3H6.1c-1.2 0-2.2-1-2.2-2.2V17.9c0-.6-.4-1-1-1s-1 .4-1 1V46c0 2.3 1.9 4.2 4.2 4.2h6.1v8.2l-4.4 2.9c-.5.3-.6.9-.3 1.4s.9.6 1.4.3l4.2-2.9 4.2 2.9c.5.3 1.1.2 1.4-.3s.2-1.1-.3-1.4L14 58.4v-8.2h8.3c.6 0 1-.4 1-1 .2-.5-.2-.9-.8-.9zM11.6 13.8c3.5 0 6.4-2.9 6.4-6.4S15.2 1 11.6 1 5.2 3.9 5.2 7.4s2.9 6.4 6.4 6.4zm0-10.8C14 3 16 5 16 7.4s-2 4.4-4.4 4.4-4.4-2-4.4-4.4S9.2 3 11.6 3zM64.1 35.7V31c0-.6-.4-1-1-1h-27c-.6 0-1 .4-1 1v4.7c0 .6.4 1 1 1h20.7v21.7H45.6c-.6 0-1 .4-1 1V64c0 .6.4 1 1 1h17.5c.6 0 1-.4 1-1zM37.2 32h25v2.7h-25zm24.9 31H46.6v-2.7h11.2c.6 0 1-.4 1-1V36.7h3.3zM40.3 24.4l2.5 1.1c1 .4 2.2-.1 2.6-1.1l1.8-4.4c1.5.3 3 0 4.1-.8V27H50c-.6 0-1 .4-1 1s.4 1 1 1h4.7c.6 0 1-.4 1-1s-.4-1-1-1h-1.3V16.7c1-2.4.1-5.2-2.1-6.6l1.8-4.4c.2-.5.2-1 0-1.5-.1-.6-.5-1-1-1.2l-2.5-1.1c-1-.4-2.2.1-2.6 1.1l-7.8 18.7c-.4 1.1 0 2.3 1.1 2.7zm7.8-6.4 2.5-6c2.6 2.1.8 6.3-2.5 6zm.7-14.2 2.5 1.1C50 8 46.6 16.3 43.6 23.6L41 22.5z",
    fill: "#fe4e4e",
    "data-original": "#fe4e4e",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.2ca070590a368c08fbb8fe1e2516a3a2.svg";
export { ForwardRef as ReactComponent };